import dayjs, { Dayjs } from "dayjs"
import { Task, TaskValidators, Validation, WeekDay } from "../types"

export const getTaskValidators = (task: Task | null) => {
  const validators: TaskValidators = {
    name: (title: string) => {
      const isValid = Boolean(title.trim())
      const message = isValid ? null : 'Title is required.'
      const validation: Validation = { isValid, message }
      
      return validation
    },
    assignedTo: (userId: string) => {
      const isValid = Boolean(userId)
      const message = isValid ? null : 'Assign To is required.'
      const validation: Validation = { isValid, message }
      
      return validation
    },    
    startDate: (startDate: Dayjs | null) => {
      const today = dayjs()

      let isValid = false
      let message = null

      if (task?.startDate) {
        isValid = true
      } else if (dayjs(startDate).isValid() && !dayjs(startDate).isBefore(today, 'day')) {
        isValid = true
      }

      if (!dayjs(startDate).isValid()) {
        message = 'Start Date is required.'
      } else if (dayjs(startDate).isBefore(today, 'day')) {
        message = 'Start Date cannot be a past date.'
      }

      const validation: Validation = { isValid, message }
      
      return validation
    },
    endDate: (startDate: Dayjs | null, endDate: Dayjs | null, noEndDate: boolean) => {
      const today = dayjs()

      const baseline = task && startDate && startDate.isBefore(today)
        ? today.clone().subtract(1, 'day')
        : today

      let isValid = false
      let message = null

      if (noEndDate) {
        isValid = true
      } else if (startDate && endDate && endDate.isAfter(startDate, 'day') && endDate.isAfter(baseline, 'day')) {
        isValid = true
      } else if (endDate && endDate.isAfter(baseline, 'day')) {
        isValid = true
      }

      if (!noEndDate) {
        if (!endDate) {
          message = 'End Date is required.'
        } else if (startDate && endDate.isSame(startDate, 'day')) {
          message = 'End Date must be after Start Date'
        } else if (startDate && !endDate.isAfter(startDate, 'day')) {
          message = 'End Date cannot be before Start Date.'
        } else if (!endDate.isAfter(baseline, 'day')) {
          message = 'End Date must be a future date.'
        }
      }

      const validation: Validation = { isValid, message }
      
      return validation
    },
    weekdays: (days: WeekDay[]) => {
      const isValid = Boolean(days.length)
      const message = isValid ? null : 'Occurence is required.' 
      const validation: Validation = { isValid, message }
      
      return validation
    },    
    weekly: (interval: string) => {
      const isValid = Number(interval) >= 1 && Number(interval) <= 52
      const message = isValid ? null : 'Please enter a value between 1 and 52 weeks.'
      const validation: Validation = { isValid, message }
      
      return validation
    },
    dayOfMonth: (day: string) => {
      const isValid = Boolean(day.trim())
      const message = isValid ? null : 'Occurence is required.'
      const validation: Validation = { isValid, message }
      
      return validation
    },
  }

  return validators
}
